var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "offline-container" }, [
    _c("div", {
      staticClass: "offline-branding",
      style: {
        backgroundImage:
          "url(" + require("@/assets/images/pitaya_wordmark_black.png") + ")",
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "offline-center-screen" },
      [
        _c("h1", [_vm._v(" Uh oh... ")]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm.connectionOverride
          ? _c(
              "b-button",
              {
                on: {
                  click: function ($event) {
                    return _vm.$emit("connectionOverridden")
                  },
                },
              },
              [_vm._v("Hide This Screen")]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(" Looks like your internet connection is down. "),
      _c("br"),
      _vm._v("Please reconnect to continue Pitaya-ing. "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }